import React from 'react'

const Footer = () => {
  return (
    <div className='text-base ml__background--black text-white py-3.5 text-center'>
        <p>© Macro Logistics 2022</p>
    </div>
  )
}

export default Footer